import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faEye, faPenToSquare, faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useParams } from 'react-router-dom'
import { useGetPresencesQuery, useUpdatePresenceByAdminMutation, useUpdatePresenceMutation } from './presencesApiSlice'
import { memo, useEffect } from 'react'
import useAuth  from "../../hooks/useAuth"
import getFilePath from '../../utils/getFilePath'
const Presence = ({ presence, reason }) => {
    const {groupId, type} = useParams()
    const navigate = useNavigate()
    const [updatePresence, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdatePresenceMutation()
    const [updatePresenceByAdmin, {
        isLoading: isLoadingByAdmin,
        isSuccess: isSuccessByAdmin,
        isError: isErrorByAdmin,
        error: errorByAdmin
    }] = useUpdatePresenceByAdminMutation()

    useEffect(() => {
        if (isSuccess ) {           
            //navigate(`/${type}/${groupId}/my-presence`)
        }

    }, [isSuccess, navigate])
    const {isAdmin, isStudent} = useAuth()
    if (presence) {
      
        const cellStatus = presence.present ? '' : 'table__cell--inactive'
        const handleEdit = ()=>{
            updatePresence({id:presence._id})
        }
        const handleEditByAdmin = ()=>{
            updatePresenceByAdmin({id:presence._id, reason, lessonId:presence.lesson})
        }


        return (
            <tr className="table__row presence">
                <td className={`table__cell ${cellStatus}`}>
                    {presence.lessonTitle}  <span className='small-text'>{presence.group?.name}</span>
                </td>
                <td className={`table__cell ${cellStatus}`}>
                    {presence.numberOfLessons}
                </td>
                <td className={`table__cell ${cellStatus}`}>
                    {presence.dt.toString().slice(0,10)}
                   
                   </td>
               
                <td className={`table__cell ${cellStatus}`}>
                    {presence.username}
                    
                    </td>  
                <td className={`table__cell ${cellStatus}`}>
                    <span className="d-flex">
                    {presence.name}
                    </span>
                    
                </td>  
                <td className={`table__cell ${cellStatus}`}>
                    {presence.present &&     <FontAwesomeIcon className='status--completed' icon={faCheckCircle} /> }
                    {!presence.present &&   <FontAwesomeIcon className='status--open' icon={faTimesCircle} /> }
                    {presence.present? ' V ':' ---'}
                    {presence.byAdmin && <span className='small-txt'>[עדכון מנהל]</span>}
                </td>  
              
                <td className={`table__cell ${cellStatus}`}>
                  { !isAdmin && !presence.present && (new Date( presence.toDate )> new Date() && new Date( presence.fromDate) < new Date() && !presence.present)  && <button
                        className="icon-button table__button"
                        onClick={handleEdit}
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </button>
                }
             
                  {isAdmin  && <button
                        className=" table__button"
                        onClick={handleEditByAdmin}
                    >
                        עדכון מנהל
                    </button>
                }
                

                   
                </td>
            </tr>
        )

    } else return null
}

const memoizedPresence = memo(Presence)

export default memoizedPresence